import React, { Component } from 'react';
import "./horizontalScroller.css";
import backButton from "./back-chevron.png";
import nextButton from "./next-chevron.png";

export default class extends Component {
  constructor(props) {
      super(props);
      this.leftButton = React.createRef();
      this.rightButton = React.createRef();
      this.scroller = React.createRef();
      this.state = {
          componentReady: 'ready'
      };
  }
  checkPosition = () =>{
    let scroller = this.scroller.current
    if(scroller.outerWidth > window.outerWidth){
      scroller = true;
    }
  }
  scrollLeft = () =>{
    let scroller = this.scroller.current
    let leftValue = scroller.scrollLeft;
    let value = leftValue-(scroller.offsetWidth * .80);
    if(window.innerWidth < 800){
      value = leftValue-scroller.offsetWidth;
    }
    scroller.scroll({
      left:value,
      behavior: 'smooth'
    });
  }
  scrollRight = () =>{
    let scroller = this.scroller.current
    let leftValue = scroller.scrollLeft;
    let value = leftValue+(scroller.offsetWidth * .80);
    if(window.innerWidth < 800){
      value = leftValue+scroller.offsetWidth;
    }
    scroller.scroll({
      left: value,
      behavior: 'smooth'
    });
  }
  render() {
    return (
      <div className="horizontal-scroller-wrapper">
        {!this.state.hideArrows && <img ref={this.leftButton} className="scroll-left-button scroll-button" onClick={this.scrollLeft} src={backButton} />}
        {!this.state.hideArrows && <img ref={this.rightButton} className="scroll-right-button scroll-button" onClick={this.scrollRight} src={nextButton} />}
        <div ref={this.scroller} className="horizontal-scroller">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/horizontalScroller/index.js